import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's141g-s141m01',
    templateUrl: './s141g-s141m01.component.html'
})
export class S141gS141m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    locncd: any = {'value': '___'};
    zoneid: any = {'value': '____'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'locncd', 'zoneid', 'msgln'];
    public LINES: number[] = [1, 2, 3, 5, 6, 22, 8, 24, 10];

    ngAfterViewInit(): void {
    }
}
